import { BaseSdk } from '../../base.sdk';
import { LinkedinConnectionDto } from '@andsend/services-linkedin-profiles-shared';
import { GetPendingInvitationsResponse, GetConnectionsResponse } from '@andsend/services-linkedin-profiles-shared';
import { ConnectionStatus } from '@zaplify/campaigns';

export class LinkedinConnectionsSdk extends BaseSdk {
    async getConnection(memberIdOrPublicIdentifier: string) {
        return await this.get<LinkedinConnectionDto>(`${this.linkedinConnectionsPath}/${memberIdOrPublicIdentifier}`);
    }

    async createPendingConnections(connections: GetPendingInvitationsResponse) {
        return await this.post<void>({
            path: `${this.linkedinConnectionsPath}/pending`,
            payload: connections,
        });
    }

    async createConnections(connections: GetConnectionsResponse) {
        return await this.post<void>({
            path: `${this.linkedinConnectionsPath}/accepted`,
            payload: connections,
        });
    }

    async getConnectionStatus(memberId: string) {
        return await this.get<ConnectionStatus>(`${this.linkedinConnectionsPath}/connection-status/${memberId}`);
    }

    async getConnectionSyncProgress() {
        return await this.get<{
            totalConnections: number;
            syncedConnections: number;
            syncedProfiles: number;
        }>(`${this.linkedinConnectionsPath}/sync-progress`);
    }
}
